import React from 'react'
import './about.css'
import Aboutimg from '../../items/Pic2about.jpeg'
import WisteliCertificate from '../../items/wisteli_certificate.jpg'
import HRCInternship from '../../items/HRC_Internship.PNG'
import HRCProject from '../../items/HRC_Project.jpg'
import { FaAward } from 'react-icons/fa'
import { VscFolderLibrary } from 'react-icons/vsc'
import { MdOutlineWorkOutline } from 'react-icons/md'
import { BsBook } from 'react-icons/bs'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";


const About = () => {
  var settings = {
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 1,
    slidesToScroll: 1
  };
  return (
    <section id='about'>
      <h5>Get To Know</h5>
      <h2>About Me</h2>
      <div className='container about__container'>
        <div className='slik'>
          <Slider {...settings}>
            <div className='carousel_img'>
              <img src={WisteliCertificate} alt="wisteli" />
            </div>
            <div>
              <img src={HRCInternship} alt="hrc_internship" />
            </div>
            <div>
              <img src={HRCProject} alt="hrc_project" />
            </div>
          </Slider>
        </div>
        <div className='about__content'>
          <div className="about__cards">
            <article className='about__card'>
              <MdOutlineWorkOutline className='about__icon' />
              <h5>Works at Wisteli</h5>
              <small>Angular Developer</small><br />
              <small>June 2022 - Present</small>
            </article>
            <article className='about__card'>
              <FaAward className='about__icon' />
              <h5>Past Experience</h5>
              <small>1 year Internship at Highradius</small> <br />
              <small>Aug 2021 - May 2022</small>
            </article>
            <article className='about__card'>
              <a href="#portfolio">
                <VscFolderLibrary className='about__icon' />
                <h5>Projects</h5>
                <small>5 Projects</small>
              </a>
            </article>
            <article className='about__card'>
              <BsBook className='about__icon' />
              <h5>Studied at</h5>
              <small>Chandigarh University</small> <br />
              <small>2018 - 2022</small>
            </article>
          </div>
          <p>
            Well-organized, goal oriented Computer Science graduate with a flair to explore suitable avenues in Computer Science
            and a Highly capable leader having led multiple projects to completion with efficiency and quality.
            Proficient in a range of modern technologies including Angular, Java, JavaScript, Typescript and Python.
          </p>
          <a href="#contact" className='btn btn-primary'>Let's Talk</a>
        </div>
      </div>
    </section>
  )
}

export default About